<template>
  <div
    class="mx-auto flex min-h-[calc(100dvh-64px)] max-w-4xl flex-col pb-2 md:h-[calc(100dvh-80px)] md:min-h-auto md:pb-10"
  >
    <div class="flex grow flex-col justify-center">
      <h3
        class="text-headline-small md:text-display-small lg:text-display-medium mb-10 text-center"
      >
        {{ $t('common.feedbackTo') + ' ' + receiverName }}
      </h3>
      <div class="flex w-full flex-row items-center justify-center">
        <FinishFeedbackProgress
          :number-of-feedbacks="numberOfFeedbacks"
          :number-of-questions="numberOfQuestions"
          :percentage="percentage"
        />
      </div>
      <FinishFeedbackQuestionList
        :questions="questionsWithFeedback"
        @navigate="navigateToQuestionById"
      />
    </div>
    <div class="flex w-full flex-row items-end justify-between px-2">
      <BaseTextButton icon="keyboard_arrow_left" size="M" color="text" @click="goBackToFeedback">{{
        $t('common.back')
      }}</BaseTextButton>
      <BaseTextButton
        size="M"
        color="filled"
        icon="send"
        @click="
          () => {
            save()
          }
        "
        >{{ $t('common.feedback-done') }}</BaseTextButton
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { toRef } from 'vue'
  import { injectStrict } from '../../../../core/utils/inject-strict'
  import { giveFeedbackKey } from '../../composables/useGiveStructuredFeedback'
  import { useFinishFeedbackSummary } from '../../composables/use-finish-feedback-summary'
  import type { QuestionGroup } from '../../models/question-group'
  import BaseTextButton from '../../../../core/components/base/button/text-button/BaseTextButton.vue'
  import FinishFeedbackProgress from './FinishFeedbackProgress.vue'
  import FinishFeedbackQuestionList from './FinishFeedbackQuestionList.vue'

  interface Props {
    questionGroups: ReadonlyArray<QuestionGroup>
    receiverName: string
  }

  const props = defineProps<Props>()

  const { feedbacks, save, navigateToQuestionById } = injectStrict(giveFeedbackKey)

  const { numberOfQuestions, numberOfFeedbacks, percentage, questionsWithFeedback, lastQuestion } =
    useFinishFeedbackSummary(toRef(props, 'questionGroups'), feedbacks)

  const goBackToFeedback = () => {
    navigateToQuestionById(lastQuestion.value)
  }
</script>
